// 權杖牌組 (Suit of Wands) - 14張
// 使用 Wikipedia Commons 官方圖庫確保穩定性
const wandsImages = {
  1: 'https://upload.wikimedia.org/wikipedia/commons/1/11/Wands01.jpg',
  2: 'https://upload.wikimedia.org/wikipedia/commons/0/0f/Wands02.jpg',
  3: 'https://upload.wikimedia.org/wikipedia/commons/f/ff/Wands03.jpg',
  4: 'https://upload.wikimedia.org/wikipedia/commons/a/a4/Wands04.jpg',
  5: 'https://upload.wikimedia.org/wikipedia/commons/9/9d/Wands05.jpg',
  6: 'https://upload.wikimedia.org/wikipedia/commons/3/3b/Wands06.jpg',
  7: 'https://upload.wikimedia.org/wikipedia/commons/e/e4/Wands07.jpg',
  8: 'https://upload.wikimedia.org/wikipedia/commons/6/6b/Wands08.jpg',
  9: 'https://upload.wikimedia.org/wikipedia/commons/4/4d/Wands09.jpg',
  10: 'https://upload.wikimedia.org/wikipedia/commons/0/0b/Wands10.jpg',
  11: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/Wands11.jpg',
  12: 'https://upload.wikimedia.org/wikipedia/commons/1/16/Wands12.jpg',
  13: 'https://upload.wikimedia.org/wikipedia/commons/0/0d/Wands13.jpg',
  14: 'https://upload.wikimedia.org/wikipedia/commons/c/ce/Wands14.jpg'
};

export const wands = [
  {
    id: 'w1',
    name: '權杖一',
    nameEn: 'Ace of Wands',
    img: wandsImages[1],
    upright: {
      keywords: ['靈感', '新目標', '熱情', '行動力'],
      meaning: '一個充滿熱情與靈感的新起點。你內心有一股想行動的衝動,現在正是將想法化為現實的好時機。'
    },
    reversed: {
      keywords: ['拖延', '缺乏動力', '失去熱情'],
      meaning: '你可能感到精力耗盡或缺乏方向感。不要強迫自己立刻行動,先找回當初的初衷。'
    }
  },
  {
    id: 'w2',
    name: '權杖二',
    nameEn: 'Two of Wands',
    img: wandsImages[2],
    upright: {
      keywords: ['規劃', '遠見', '抉擇', '踏出舒適圈'],
      meaning: '你已經有了初步的基礎,現在正望向更遠的地方。這是一個關於未來規劃與做出大膽抉擇的時刻。'
    },
    reversed: {
      keywords: ['害怕未知', '安於現狀', '計畫受阻'],
      meaning: '你可能因為害怕失敗而不敢踏出舒適圈,或是過度規劃卻遲遲沒有行動。'
    }
  },
  {
    id: 'w3',
    name: '權杖三',
    nameEn: 'Three of Wands',
    img: wandsImages[3],
    upright: {
      keywords: ['擴展', '前瞻', '合作', '期待成果'],
      meaning: '你的努力開始有了方向,船隻即將準備出航。這是一個擴展視野、尋求合作的階段。'
    },
    reversed: {
      keywords: ['延誤', '視野狹隘', '合作破局'],
      meaning: '預期的進展可能遭遇了延誤,或者你把自己侷限在太小的格局裡了。'
    }
  },
  {
    id: 'w4',
    name: '權杖四',
    nameEn: 'Four of Wands',
    img: wandsImages[4],
    upright: {
      keywords: ['慶祝', '和諧', '里程碑', '歸屬感'],
      meaning: '這是一個值得慶祝的小里程碑。你找到了一個充滿安全感與歸屬感的環境,享受當下吧。'
    },
    reversed: {
      keywords: ['不穩定', '短暫的快樂', '缺乏安全感'],
      meaning: '雖然表面看似歡樂,但根基可能不夠穩固,或者你內心依然感到某種漂泊感。'
    }
  },
  {
    id: 'w5',
    name: '權杖五',
    nameEn: 'Five of Wands',
    img: wandsImages[5],
    upright: {
      keywords: ['競爭', '衝突', '意見不合', '腦力激盪'],
      meaning: '周圍充滿了紛雜的聲音與小摩擦。把它當作一場良性競爭或腦力激盪,不要太往心裡去。'
    },
    reversed: {
      keywords: ['迴避衝突', '達成共識', '內耗'],
      meaning: '你可能正在逃避必要的爭論,或者終於從混亂中找到了和平解決的方法。'
    }
  },
  {
    id: 'w6',
    name: '權杖六',
    nameEn: 'Six of Wands',
    img: wandsImages[6],
    upright: {
      keywords: ['勝利', '認可', '自信', '好消息'],
      meaning: '恭喜!你的努力得到了外界的認可與讚賞。帶著這份自信繼續前進,享受屬於你的榮耀。'
    },
    reversed: {
      keywords: ['驕傲自滿', '缺乏認可', '跌落神壇'],
      meaning: '可能因為過度自信而遭遇挫折,或者你覺得自己的努力始終沒有被人看見。'
    }
  },
  {
    id: 'w7',
    name: '權杖七',
    nameEn: 'Seven of Wands',
    img: wandsImages[7],
    upright: {
      keywords: ['防禦', '堅持', '挑戰', '守護信念'],
      meaning: '你正面臨來自四面八方的挑戰。請堅守你的立場,你有足夠的能力捍衛自己所珍視的事物。'
    },
    reversed: {
      keywords: ['妥協', '力不從心', '放棄立場'],
      meaning: '壓力大到讓你想要放棄,或者你因為過度防衛而推開了原本想幫你的人。'
    }
  },
  {
    id: 'w8',
    name: '權杖八',
    nameEn: 'Eight of Wands',
    img: wandsImages[8],
    upright: {
      keywords: ['迅速', '進展', '溝通', '突如其來'],
      meaning: '事情正在快速發展!阻礙已經消除,這是一個充滿動能、消息快速流通的時期。'
    },
    reversed: {
      keywords: ['延遲', '倉促', '溝通不良'],
      meaning: '事情進展太快導致失控,或者你期待的消息遲遲沒有到來,讓人感到焦慮。'
    }
  },
  {
    id: 'w9',
    name: '權杖九',
    nameEn: 'Nine of Wands',
    img: wandsImages[9],
    upright: {
      keywords: ['疲憊', '堅持', '警覺', '最後一哩路'],
      meaning: '你已經受了傷,感到非常疲憊,但在這最後一刻依然堅守崗位。再撐一下,終點就在眼前。'
    },
    reversed: {
      keywords: ['放棄', '過度防衛', '不堪重負'],
      meaning: '你可能把圍牆築得太高,拒絕了他人的幫助,或者真的已經到達了極限而想要放棄。'
    }
  },
  {
    id: 'w10',
    name: '權杖十',
    nameEn: 'Ten of Wands',
    img: wandsImages[10],
    upright: {
      keywords: ['重擔', '責任', '壓力', '過勞'],
      meaning: '你把太多的責任扛在自己肩上,壓得喘不過氣。請考慮放下一些不必要的包袱。'
    },
    reversed: {
      keywords: ['卸下重擔', '崩潰', '逃避責任'],
      meaning: '你終於意識到自己無法承擔所有事,開始學會放手;或者壓力已經導致了身心的崩潰。'
    }
  },
  {
    id: 'w11',
    name: '權杖侍者',
    nameEn: 'Page of Wands',
    img: wandsImages[11],
    upright: {
      keywords: ['好奇心', '探索', '新消息', '自由'],
      meaning: '你像個充滿好奇心的孩子,對世界充滿渴望。這是一個探索新興趣或收到好消息的象徵。'
    },
    reversed: {
      keywords: ['三分鐘熱度', '缺乏目標', '壞消息'],
      meaning: '你可能有很多想法,卻無法堅持下去,或者只是在盲目地追尋刺激。'
    }
  },
  {
    id: 'w12',
    name: '權杖騎士',
    nameEn: 'Knight of Wands',
    img: wandsImages[12],
    upright: {
      keywords: ['行動力', '冒險', '熱情', '衝動'],
      meaning: '帶著滿腔熱血出發!你現在充滿了能量與自信,迫不及待想要征服眼前的挑戰。'
    },
    reversed: {
      keywords: ['魯莽', '脾氣暴躁', '過度衝動'],
      meaning: '你的行動可能太過急躁,沒有考慮後果。小心不要因為一時衝動而燒傷了自己或別人。'
    }
  },
  {
    id: 'w13',
    name: '權杖皇后',
    nameEn: 'Queen of Wands',
    img: wandsImages[13],
    upright: {
      keywords: ['魅力', '自信', '獨立', '溫暖'],
      meaning: '你充滿了自信與魅力,能夠溫暖並感染周圍的人。這是一個展現自我價值與獨立自主的時期。'
    },
    reversed: {
      keywords: ['嫉妒', '缺乏安全感', '強勢'],
      meaning: '你可能因為缺乏安全感而變得過度強勢或嫉妒心重,忘記了自己本來的光芒。'
    }
  },
  {
    id: 'w14',
    name: '權杖國王',
    nameEn: 'King of Wands',
    img: wandsImages[14],
    upright: {
      keywords: ['領導力', '願景', '魅力', '果斷'],
      meaning: '你具備宏大的願景與強大的領導力,能夠帶領眾人前進。用你的熱情去感染世界吧。'
    },
    reversed: {
      keywords: ['獨裁', '衝動', '暴躁'],
      meaning: '你可能變得有些獨裁,聽不進別人的意見,或者設定了過於好高騖遠的目標。'
    }
  }
];